<template>
  <EmIconButton icon="mdi-domain" v-bind="$attrs" title="This is your account" />
</template>
